import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const Category = async () => {
  try {
    return await getData(`/without-login/allcategories`);
  } catch (error) {
    console.log(error);
  }
};

export const SubCategory = async (id) => {
  try {
    return await getData(`/without-login/allsubcategories/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const singleSubCategory = async (id) => {
  try {
    return await getData(`/without-login/subcategory/${id}`);
  } catch (error) {
    console.log(error);
  }
};
export const ChildSubCategory = async (id) => {
  try {
    return await getData(`/without-login/allchildsubcategories/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const popularCategory = async () => {
  try {
    return await getData(`/without-login/all-pupular-category`);
  } catch (error) {
    console.log(error);
  }
};

export const Products = async ({
  page = "",
  category_id = "",
  best_selling = "",
  occasion_id = "",
  price_min = "",
  brand_id = "",
  material_id = "",
  price_max = "",
  quantity = "",
  customisable = "",
  partnership = "",
  gender_id = "",
  selectedSort = "",
  name = "",
}) => {
  try {
    const url = `/luxury/product?page=${page || ""}&category_id=${
      category_id !== "all" ? category_id : "" || ""
    }&best_selling=${best_selling || ""}&occasion_id=${occasion_id ||
      ""}&brand_id=${brand_id || ""}&material_id=${material_id ||
      ""}&minprice=${price_min || ""}&maxprice=${price_max ||
      ""}&partnership=${partnership || ""}&quantity=${
      quantity > 0 ? quantity : ""
    }&custom=${customisable || ""}&gender_id=${gender_id ||
      ""}&sortOption=${selectedSort || ""}&productName=${name || ""}`;

    return await getData(url);
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

export const ProductsBestSelling = async ({
  page = "",
  category_id = "",
  best_selling = "",
  occasion_id = "",
  price_min = "",
  brand_id = "",
  price_max = "",
  quantity = "",
  customisable = "",
  partnership = "",
  gender_id = "",
}) => {
  try {
    const url = `/luxury/product/best-selling?page=${page || ""}&category_id=${
      category_id !== "all" ? category_id : "" || ""
    }&best_selling=${best_selling || ""}&occasion_id=${occasion_id ||
      ""}&brand_id=${brand_id || ""}&minprice=${price_min ||
      ""}&maxprice=${price_max || ""}&partnership=${partnership ||
      ""}&quantity=${quantity > 0 ? quantity : ""}&custom=${customisable ||
      ""}&gender_id=${gender_id || ""}`;

    return await getData(url);
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

export const ProductsRecentlyView = async (page = "", productId) => {
  try {
    let url = `/product/recentely-view?page=${page}`;
    // Append parameters based on their presence
    if (productId) {
      url += `&product_id=${encodeURIComponent(productId)}`;
    }

    // Return the result from the API call
    return await getData(url);
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

// export const Products = async (page = '', category_id = "", sub_category_id = "", child_sub_category_id = "", seller_id = "", brand_id = "", material_id = "", occasion_id = "", price_value = "", sustainable = "", promotional = "", product_id = '', productName, occationId,custom) => {

//   try {
//     let url = `/product?page=${page}`;
//     if (productName) {
//       url += `&productName=${productName}`;
//     } else
//       if (promotional) {
//         url += `&promotional=${promotional}`;
//       } else if (sustainable) {
//         url += `&sustainable=${sustainable}`;
//       } else
//         if (category_id && sub_category_id && child_sub_category_id && seller_id) {
//           url += `&category_id=${category_id}&sub_category_id=${sub_category_id}&child_sub_category_id=${child_sub_category_id}&seller_id=${seller_id}`;
//         } else if (brand_id && sub_category_id) {
//           url += `&sub_category_id=${sub_category_id}&brand_id=${brand_id}`;
//         } else if (occasion_id && sub_category_id) {
//           url += `&sub_category_id=${sub_category_id}&occasion_id=${occasion_id}`;
//         } else if (material_id && sub_category_id) {
//           url += `&sub_category_id=${sub_category_id}&material_id=${material_id}`;
//         } else if (price_value && sub_category_id) {
//           url += `&sub_category_id=${sub_category_id}&minprice=${price_value?.min}&maxprice=${price_value?.max}`;
//         }
//         else if (category_id) {
//           url += `&category_id=${category_id}`;
//         } else if (sub_category_id) {
//           url += `&sub_category_id=${sub_category_id}`;
//         } else if (child_sub_category_id) {
//           url += `&child_sub_category_id=${child_sub_category_id}`;
//         } else if (product_id) {
//           // product_id.forEach(id => queryParams.push(`product_id=${id}`));
//           url += `&product_id=${product_id}`;
//         } else if (occationId) {
//           url += `&occasion_id=${occationId}`;
//         }
//         else if (custom) {
//           url += `&custom=${custom}`;
//         }

//     if (seller_id) {
//       url += `&seller_id=${seller_id}`;
//     }
//     return await getData(url);
//   } catch (error) {
//     console.log(error);
//   }
// };

export const getProductDetail = async (id) => {
  try {
    return await getData(`/luxury/product/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const getCategoryProduct = async (id) => {
  try {
    return await getData(`/product/category-product/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const getAllCategoryProduct = async (id) => {
  try {
    return await getData(`/product/category-product`);
  } catch (error) {
    console.log(error);
  }
};

export const getProductVariant = async (id) => {
  try {
    return await getData(`/product/variants/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const getVariant = async (id) => {
  try {
    return await getData(`/product/variant/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const allProductReviewGet = async (id) => {
  try {
    return await getData(`/without-login/home/show/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const productReviewGet = async (id) => {
  try {
    return await getData(`/review/show/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const productReviewPostLuxury = async (data) => {
  try {
    return await postData(`/luxury/review/add`, data);
  } catch (error) {
    console.log(error);
  }
};

export const productList = async () => {
  try {
    return await getData(`/without-login/product`);
  } catch (error) {
    console.log(error);
  }
};
